import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import styles from './index.module.scss';

const Maximum = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    return (
        <div className={`${styles.maximum} GtmModuleData-section`} data-section-id={styles.maximum} data-section-title={t(`mmaximum_title`)}>
            <div className="text-container">
                <h5 className="label">
                    {t.rich('mmaximum_label', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </h5>
                <h2>{t(`mmaximum_title`)}</h2>
                <p className="intro">{t(`mmaximum_intro`)}</p>
            </div>

            <div className="content">
                <EFPicture
                    src="https://websiteoss.ecoflow.com/upload/image/1759999611625/mmaximum-pc.jpg"
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1759999611527/mmaximum-h5.jpg"
                    alt={t(`mmaximum_title`)}
                    className="banner"
                />
                {/* <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1751333383988/15year.png" alt={t(`mmaximum_label`)} className="year" /> */}
            </div>
        </div>
    );
};

export default Maximum;
